import type { GetLandingPageQuery } from "@dustin-web/microsite-data/src/graphql/product/generated/graphql-types";

export type LandingPage = NonNullable<GetLandingPageQuery["landingPage"]>;
export type LandingPageRecommendationList = NonNullable<NonNullable<LandingPage["recommendationList"]>[number]>;
export type LandingPageProductReference = NonNullable<NonNullable<LandingPageRecommendationList["productReferences"]>[number]>;

export type LandingPageGroupList = {
  attributes: LandingPageAttributes,
  productReferences: LandingPageProductReference[]
}

export enum ListingType {
  MultiSlider = 'multi-slider',
  Aside = 'aside',
  Slider = 'slider',
  List = 'list',
}

export interface LandingPageAttributes {
  /** Indicates whether the item should be sticky on large screens. */
  stickyOnLarge?: boolean

  /** Text for the call-to-action (CTA) button or link. */
  ctaText?: string

  /** The display name of the group. */
  groupDisplayName?: string

  /** The display name of the page or item. */
  displayName?: string

  /** The color theme used for the page or item. */
  colorTheme?: string

  /** The type of product listing. */
  productListingType?: ListingType

  /** A call-to-action link key to their respective URL. */
  ['ctaLink_en-us']?: string

  /** A call-to-action link key to their respective URL. */
  ['ctaLink_nb-no']?: string

  /** A call-to-action link key to their respective URL. */
  ['ctaLink_da-dk']?: string

  /** A call-to-action link key to their respective URL. */
  ['ctaLink_fi-fi']?: string

  /** A call-to-action link key to their respective URL. */
  ['ctaLink_nl-nl']?: string

  /** A call-to-action link key to their respective URL. */
  ['ctaLink_sv-se']?: string
}

